<template>
    <div class="ui-input ui-select ui-select-color" :class="inputClass" :ref="selectID" >
        <div class="label" v-if="label" >
            <span v-text="label" ></span>
            <span class="label-required" v-if="required" > *</span>
        </div>
        <div class="ui-select-box" :class="selectBoxClass" >
            <div class="selected" :class="selectedClass" @click="toggle" > 
                <div v-show="selected" :style="'background-color:' + selected"  class="selected-color"></div>
                <span v-text="selected ? selected : placeholder" ></span>
            </div>

            <div class="options" v-if="open" >
                <section class="search" v-if="openAdd">
                    <div class="search-box">
                        <input type="text" v-mask="{mask: mask, tokens: hexTokens}" ref="search" placeholder="Adicionar cor" v-model="text" >
                        <div class="icon" :class="{'disabled' : disabledIcon}" >
                            <em class="fal fa-plus" @click="callback" ></em>
                        </div>
                    </div>
                </section>
                <section class="list">
                    <div class="items scroll-color" ref="scroller" >
                        <div 
                            v-for="(color, i) in items"

                            :key="'color-' + i" 
                            :style="'background-color:' + color" 

                            class="item" 

                            @click="select(color)"
                        ></div>
                    </div>
                </section>
            </div>
        </div>
    </div>
</template>
<script>
    import { mask } from 'vue-the-mask'

    export default {
        props: {
            /**
             * V-model
            */
            value: {
                required: true,
                type: [String, Array]
            },

            /**
             * 
            */
            colors: {
                type: Array,
                required: true,
                default: () => [],
            },

            /**
             * Array de cores desabilitadas
            */
            disabledColor: {
                type: Array,
                required: false,
                default: () => [],
            },

            /**
             * 
            */
            label: {
                type: String,
                required: false,
            },

            /**
             * Define o tamanho do campo, tendo como valores:
             * xs - muito pequeno.
             * sm - pequeno
             * md - medio
             * lg - grande
             * xl - muito grande
             * xxl - gigante
             * xxxl - muito gigante
            */
            size: {
                type: String,
                required: false,
                default: 'md',
            },

            /**
             * Define para qual lado será aberto as opções de cores.
            */
            align: {
                type: String,
                required: false,
                default: 'left',
            },

            /**
             * Define se o campo esta habilitado
            */
            disabled: {
                type: Boolean,
                required: false,
                default: false,
            },

            /**
             * Define se o campo é obrigatório
            */
            required: {
                type: Boolean,
                required: false,
            },

            /**
             * Define o texto a aparecer no componente
            */
            placeholder: {
                type: String,
                required: false,
                default: 'Selecione uma cor',
            },

            /**
             * Define se o campo deve ser fechado ao adicionar uma cor
            */
            closeOnAdd: {
                type: Boolean,
                required: false,
                default: false,
            },

            /**
             * Define se o campo terá a opção de adicionar uma nova cor
            */
            openAdd: {
                type: Boolean,
                required: false,
                default: false,
            },

            /**
             * Define se o icone de loading irá aparecer
            */
            loading: {
                type: Boolean,
                required: false,
                default: false,
            },
            invalid: {
                type: Boolean,
                required: false,
                default: false,
            },
        },

        directives: {
            mask
        },

        data() {
            return {
                selected: null,
                open: false,
                text: '',
                id: this._uid,

                mask: '\#FFFFFF',
                hexTokens: {
                    'F': {
                        pattern: /[0-9a-fA-F]/,
                        transform: v => v.toLocaleUpperCase()
                    }
                }
            }
        },

        created() {
            window.addEventListener('click', this.close)
        },

        beforeDestroy() {
            window.removeEventListener('click', this.close)
        },

        computed: {
            selectID(){
                return 'select-' + this.id
            },

            inputClass() {
                return [
                    this.size,
                    this.align,
                    this.open ? 'open' : '',
                ]
            },

            selectedClass() {
                return [
                    this.loading ? 'load disabled' : '',
                    this.disabled ? 'disabled' : '',
                ]
            },

            selectBoxClass() {
                return [
                    this.error ? 'error' : '',
                ]
            },

            items(){
                /**
                 * Filtra as cores baseado no array de cores desabilitadas
                */
                return this.colors.filter((e) => {
                    if (!this.disabledColor.includes(e)) {
                        return e
                    }
                })
            },

            disabledIcon() {
                const l = this.text.length - 1
                return l < 3 || l == 5 || l > 6
            }
        },

        methods: {
            toggle() {
                this.open = !this.open
            },

            select(color) {
                if (this.selected && this.selected === color) {
                    this.selected = null

                    this.$emit('input', this.selected)
                    this.toggle()

                    return
                }

                this.selected = color

                this.$emit('input', this.selected)
                this.toggle()
            },

            callback() {
                const color = this.text
                this.colors.push(color)
                this.$emit('add', this.colors)

                if(this.closeOnAdd) this.select(color)

                this.text = ''
            },

            close(e) {
                if(!this.$refs[this.selectID].contains(e.target)){
                    this.open = false
                }
            }
        },
        watch: {
            value(value) {
				this.selected = value
			},

			selected(value) {
				this.$emit('input', value)
			},
        }
    }
</script>
<style lang="stylus" scoped>
	@import 'styles.styl'
</style>